import { Layout } from 'antd'
import styled from 'config/theme/styledWithTheme'
import React from 'react'

const CLASS_MAIN_LAYOUT = 'layout_main'

interface ILayoutCPProps {
    mainLayout?: boolean
    header?: JSX.Element
    content?: JSX.Element | false
    sider?: JSX.Element | false
    footer?: JSX.Element
}

/**
 * COMPONENTE
 * Renderiza o layout padrao do sistema.
 */
export function LayoutCP(props: ILayoutCPProps): JSX.Element {
    return (
        <WrapperSCP className={!!props.mainLayout ? CLASS_MAIN_LAYOUT : ''}>
            <Layout>
                {props.header}

                <Layout>
                    {props.sider}
                    {props.content}
                </Layout>

                {props.footer}
            </Layout>
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div`
    &,
    .ant-layout {
        overflow: hidden;
        height: 100%;
        width: 100%;
    }

    &.${CLASS_MAIN_LAYOUT} {
        > .ant-layout {
            height: 100vh;
            height: calc(var(--vh, 1vh) * 100);
            width: 100vw;
        }
    }
`
